import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import { BLOCKS } from '@contentful/rich-text-types'
import merge from 'deepmerge'

const getDefaultOptions = (classes = {}) => {
  const getClass = getConvenienceClassFn(classes)
  return {
    renderNode: {
      [BLOCKS.HEADING_1]: (node, children) => (
        <h1 className={`BEURO__hero ${getClass(BLOCKS.HEADING_1)}`}>{children}</h1>
      ),
      [BLOCKS.HEADING_2]: (node, children) => (
        <h2 className={`BEURO__section-header ${getClass(BLOCKS.HEADING_2)}`}>{children}</h2>
      ),
      [BLOCKS.HEADING_3]: (node, children) => (
        <h3 className={`BEURO__overline ${getClass(BLOCKS.HEADING_3)}`}>{children}</h3>
      ),
      [BLOCKS.HEADING_4]: (node, children) => (
        <h4 className={`BEURO__subsection-header ${getClass(BLOCKS.HEADING_4)}`}>{children}</h4>
      ),
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <p className={`BEURO__body ${getClass(BLOCKS.PARAGRAPH)}`}>{children}</p>
      ),
      [BLOCKS.UL_LIST]: (node, children) => (
        <ul className={getClass(BLOCKS.UL_LIST)}>{children}</ul>
      ),
      [BLOCKS.LIST_ITEM]: (node, children) => {
        node.content.forEach(replaceNestedP)
        return <li className={`BEURO__list-item ${getClass(BLOCKS.LIST_ITEM)}`}>{children}</li>
      },
      span: (node, children) => <span className={getClass('span')}>{children}</span>,
    },
  }
}

function replaceNestedP(node) {
  if (node.nodeType === BLOCKS.PARAGRAPH) {
    node.nodeType = 'span'
  }
}

export default function RichText({ document, classes = {}, ...options }) {
  const defaultOptions = getDefaultOptions(classes)
  return documentToReactComponents(document, merge(defaultOptions, options))
}

// Helpers to make your life easier
function getConvenienceClassFn(classes = {}) {
  return blockName => {
    return classes[blockName] || classes[CONVENIENCE_NAMES[blockName]] || ''
  }
}

const CONVENIENCE_NAMES = {
  [BLOCKS.HEADING_1]: 'h1',
  [BLOCKS.HEADING_2]: 'h2',
  [BLOCKS.HEADING_3]: 'h3',
  [BLOCKS.HEADING_4]: 'h4',
  [BLOCKS.HEADING_5]: 'h5',
  [BLOCKS.HEADING_6]: 'h6',
  [BLOCKS.PARAGRAPH]: 'p',
  [BLOCKS.UL_LIST]: 'ul',
  [BLOCKS.LIST_ITEM]: 'li',
}
